document.addEventListener('DOMContentLoaded', () => {
    const nav = document.querySelector('.section-nav');
    if (!nav) return;

    const isClickMode = () => window.innerWidth < 992 || nav.classList.contains('collapsed-nav');

    const titleWrapper = nav.querySelector<HTMLDivElement>('.section-nav__title-wrapper');
    const titleToggle = nav.querySelector<HTMLButtonElement>('.section-nav__title-toggle');
    const dropdownsWrapper = nav.querySelector<HTMLDivElement>('.section-nav__dropdowns-wrapper');

    const syncTitleToggleAccessibility = () => {
        if (!titleToggle) return;

        const shouldBeFocusable = isClickMode();
        titleToggle.tabIndex = shouldBeFocusable ? 0 : -1;
        titleToggle.setAttribute('aria-hidden', String(!shouldBeFocusable));
    };

    syncTitleToggleAccessibility();
    window.addEventListener('resize', syncTitleToggleAccessibility);

    // Toggle full nav open/closed (mobile & collapsed desktop)
    if (titleWrapper && titleToggle && dropdownsWrapper) {
        const toggleMenu = () => {
            const isOpen = dropdownsWrapper.classList.toggle('menu-open');
            titleToggle.setAttribute('aria-expanded', String(isOpen));
            titleWrapper.classList.toggle('menu-open', isOpen);
        };

        titleToggle.addEventListener('click', () => {
            // Always active on mobile, only on desktop if collapsed-nav is present
            if (isClickMode()) {
                toggleMenu();
            }
        });
    }

    // Dropdowns: handle click vs hover toggle logic
    const dropdowns = nav.querySelectorAll<HTMLDivElement>('.section-nav__dropdown');

    dropdowns.forEach(dropdownEl => {
        const toggleBtn = dropdownEl.querySelector<HTMLButtonElement>('.section-nav__dropdown-toggle');
        const menu = dropdownEl.querySelector<HTMLUListElement>('.dropdown-menu');
        const menuLinks = menu?.querySelectorAll<HTMLAnchorElement>('a');

        const syncMenuLinkAccessibility = () => {
            if (!menuLinks) return;

            const isOpen = isClickMode()
                ? menu?.classList.contains('show') ?? false
                : dropdownEl.classList.contains('keyboard-open');

            menuLinks.forEach(link => {
                link.tabIndex = isOpen ? 0 : -1;
                link.setAttribute('aria-hidden', String(!isOpen));
            });
        };

        const setExpanded = (isOpen: boolean) => {
            toggleBtn?.setAttribute('aria-expanded', String(isOpen));
            dropdownEl.classList.toggle('keyboard-open', isOpen && !isClickMode());
            syncMenuLinkAccessibility();
        };

        const openDesktopMenu = () => {
            if (isClickMode()) return;
            setExpanded(true);
        };

        const closeDesktopMenu = () => {
            if (isClickMode()) return;
            if (dropdownEl.matches(':focus-within')) return;
            setExpanded(false);
        };

        // Skip link-only or mobile title dropdowns
        if (!toggleBtn || !menu) return;

        syncMenuLinkAccessibility();

        // MOBILE BEHAVIOR (click to toggle)
        toggleBtn.addEventListener('click', e => {
            // Prevent click from triggering navigation or hover logic
            e.preventDefault();

            // On mobile OR collapsed desktop
            if (isClickMode()) {
                const isOpen = menu.classList.toggle('show');
                setExpanded(isOpen);
            }
        });

        toggleBtn.addEventListener('keydown', e => {
            if (isClickMode()) return;

            if (e.key === 'Enter') {
                e.preventDefault();
                openDesktopMenu();
                menuLinks?.[0]?.focus();
            }

            if (e.key === 'Escape') {
                e.preventDefault();
                setExpanded(false);
                toggleBtn.focus();
            }
        });

        menu.addEventListener('keydown', e => {
            if (isClickMode() || e.key !== 'Escape') return;

            e.preventDefault();
            setExpanded(false);
            toggleBtn.focus();
        });

        dropdownEl.addEventListener('focusout', () => {
            requestAnimationFrame(closeDesktopMenu);
        });

        // Overflow adjustment (for large dropdowns near viewport edge)
        dropdownEl.addEventListener('mouseenter', () => {
            if (!isClickMode()) {
                menu.classList.remove('dropdown-overflow-left', 'dropdown-overflow-right', 'ready');

                requestAnimationFrame(() => {
                    const rect = menu.getBoundingClientRect();
                    if (rect.right > window.innerWidth) {
                        menu.classList.add('dropdown-overflow-right');
                    } else if (rect.left < 0) {
                        menu.classList.add('dropdown-overflow-left');
                    }
                    menu.classList.add('ready');

                    setExpanded(true);
                });
            }
        });

        dropdownEl.addEventListener('mouseleave', () => {
            closeDesktopMenu();
        });

        window.addEventListener('resize', syncMenuLinkAccessibility);
    });
});
